import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-leads',
    templateUrl: './icon-leads.component.html',
    styleUrls: ['./icon-leads.component.scss']
})
export class IconLeadsComponent implements OnInit {

    @Input() cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
